import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { checkCautionMessage, getRefundAmountType } from '@common/utils';
import SatFollowText from '@components/common/satUI/SatFollowText';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';

// 해약환급금 미지급형/일부지급형 상품 가입에 대한 계약자 확인서 > 무+저해지 상품 따라쓰기 컴포넌트
const ComplexPaymentFollowText = forwardRef((props, ref) => {
  const {
    ownerName,
    mainProductName, // 주계약 상품명
    complete,
    followTextError,
    setFollowTextError,
    // additionalText,
    // isNewProduct,
    // isJanProduct, // 2023 1월 신상품 여부(4432/4442)
    // isRiderProduct, // 특약에 저해지+무해지가 함께 있는 경우
  } = props;

  const refundAmountType = getRefundAmountType();
  const isRefundHalf = refundAmountType === 'half';
  const isCaution = checkCautionMessage();
  const isExtraFollowText = isRefundHalf;

  const followRef1 = useRef();
  const followRef2 = useRef();
  const followRef3 = useRef();
  const followRef4 = useRef();
  const followRef5 = useRef();
  const followRef6 = useRef();
  const followRef7 = useRef();
  const followRef8 = useRef();
  const followRef9 = useRef();
  const followRef10 = useRef();
  const followRef11 = useRef();
  const followRef12 = useRef();
  const followRef13 = useRef();
  const followRef14 = useRef();

  const [isValid, setIsValid] = useState([]);
  const [showError, setShowError] = useState(false);

  useImperativeHandle(ref, () => ({
    isValidCheck() {
      let validResult = true;
      if (isExtraFollowText) {
        if (
          [
            followRef1.current.getIsMatched(),
            followRef2.current.getIsMatched(),
            followRef3.current.getIsMatched(),
            followRef4.current.getIsMatched(),
            followRef5.current.getIsMatched(),
            followRef6.current.getIsMatched(),
            followRef7.current.getIsMatched(),
            followRef8.current.getIsMatched(),
            followRef9.current.getIsMatched(),
            followRef10.current.getIsMatched(),
            followRef11.current.getIsMatched(),
            followRef12.current.getIsMatched(),
            followRef13.current.getIsMatched(),
            followRef14.current.getIsMatched(),
          ].filter(item => !item).length > 0
        ) {
          validResult = false;
          setFollowTextError(true);
          setShowError(true);

          // 입력 안 된 가장 첫번째 부분에 포커스
          if (!followRef1.current.getIsMatched()) {
            followRef1.current.onFocusInput();
          } else if (!followRef2.current.getIsMatched()) {
            followRef2.current.onFocusInput();
          } else if (!followRef3.current.getIsMatched()) {
            followRef3.current.onFocusInput();
          } else if (!followRef4.current.getIsMatched()) {
            followRef4.current.onFocusInput();
          } else if (!followRef5.current.getIsMatched()) {
            followRef5.current.onFocusInput();
          } else if (!followRef6.current.getIsMatched()) {
            followRef6.current.onFocusInput();
          } else if (!followRef7.current.getIsMatched()) {
            followRef7.current.onFocusInput();
          } else if (!followRef8.current.getIsMatched()) {
            followRef8.current.onFocusInput();
          } else if (!followRef9.current.getIsMatched()) {
            followRef9.current.onFocusInput();
          } else if (!followRef13.current.getIsMatched()) {
            followRef13.current.onFocusInput();
          } else if (!followRef14.current.getIsMatched()) {
            followRef14.current.onFocusInput();
          } else if (!followRef10.current.getIsMatched()) {
            followRef10.current.onFocusInput();
          } else if (!followRef11.current.getIsMatched()) {
            followRef11.current.onFocusInput();
          } else if (!followRef12.current.getIsMatched()) {
            followRef12.current.onFocusInput();
          }
        }
      } else {
        if (
          [
            followRef1.current.getIsMatched(),
            followRef2.current.getIsMatched(),
            followRef3.current.getIsMatched(),
            followRef4.current.getIsMatched(),
            followRef5.current.getIsMatched(),
            followRef6.current.getIsMatched(),
            followRef7.current.getIsMatched(),
            followRef8.current.getIsMatched(),
            followRef9.current.getIsMatched(),
            followRef10.current.getIsMatched(),
            followRef11.current.getIsMatched(),
            followRef12.current.getIsMatched(),
          ].filter(item => !item).length > 0
        ) {
          validResult = false;
          setFollowTextError(true);
          setShowError(true);

          // 입력 안 된 가장 첫번째 부분에 포커스
          if (!followRef1.current.getIsMatched()) {
            followRef1.current.onFocusInput();
          } else if (!followRef2.current.getIsMatched()) {
            followRef2.current.onFocusInput();
          } else if (!followRef3.current.getIsMatched()) {
            followRef3.current.onFocusInput();
          } else if (!followRef4.current.getIsMatched()) {
            followRef4.current.onFocusInput();
          } else if (!followRef5.current.getIsMatched()) {
            followRef5.current.onFocusInput();
          } else if (!followRef6.current.getIsMatched()) {
            followRef6.current.onFocusInput();
          } else if (!followRef7.current.getIsMatched()) {
            followRef7.current.onFocusInput();
          } else if (!followRef8.current.getIsMatched()) {
            followRef8.current.onFocusInput();
          } else if (!followRef9.current.getIsMatched()) {
            followRef9.current.onFocusInput();
          } else if (!followRef10.current.getIsMatched()) {
            followRef10.current.onFocusInput();
          } else if (!followRef11.current.getIsMatched()) {
            followRef11.current.onFocusInput();
          } else if (!followRef12.current.getIsMatched()) {
            followRef12.current.onFocusInput();
          }
        }
      }

      return validResult;
    },
  }));

  useEffect(() => {
    if (complete) {
      if (isExtraFollowText) {
        // 2023 1월 신상품에 특약이 부가된 경우
        setIsValid(Array(14).fill(true));
      } else {
        setIsValid(Array(12).fill(true));
      }
    } else {
      if (isExtraFollowText) {
        // 2023 1월 신상품에 특약이 부가된 경우
        setIsValid(Array(14).fill(false));
      } else {
        setIsValid(Array(12).fill(false));
      }
      setTimeout(() => {
        followRef1.current.onFocusInput();
      }, 200);
    }
  }, []);

  useEffect(() => {
    if (followTextError) {
      if (isValid.filter(item => !item).length === 0) {
        setFollowTextError(false);
        setShowError(true);
      }
    }
  }, [isValid]);

  const handleMatched = (res, index) => {
    if (res) {
      const findIndex = isValid.lastIndexOf(false);
      if (findIndex > -1) {
        setIsValid(
          isValid.map((item, index) => {
            return findIndex === index ? true : item;
          }),
        );
      }

      if (!complete) {
        // 자동 포커스 이동
        setTimeout(() => {
          if (index === '1') {
            followRef2.current.onFocusInput();
          } else if (index === '2') {
            followRef3.current.onFocusInput();
          } else if (index === '3') {
            followRef4.current.onFocusInput();
          } else if (index === '4') {
            followRef5.current.onFocusInput();
          } else if (index === '5') {
            followRef6.current.onFocusInput();
          } else if (index === '6') {
            followRef7.current.onFocusInput();
          } else if (index === '7') {
            followRef8.current.onFocusInput();
          } else if (index === '8') {
            followRef9.current.onFocusInput();
          } else if (index === '9') {
            if (isExtraFollowText) {
              followRef13.current.onFocusInput();
            } else {
              followRef10.current.onFocusInput();
            }
          } else if (index === '10') {
            followRef11.current.onFocusInput();
          } else if (index === '11') {
            followRef12.current.onFocusInput();
          } else if (index === '12') {
            // 마지막란 완료 시 포커스 해제 및 서명쪽으로 스크롤 이동
            followRef12.current.onFocusBlur();
            const scrollWrapY = document
              .getElementById('signPadScroll')
              .getBoundingClientRect().top; // 스크롤 영역의 y좌표

            const currentScrollTop =
              document.getElementById('signPadScroll').scrollTop;

            const targetY = document
              .getElementById('signPadWrap')
              .getBoundingClientRect().top;

            document.getElementById('signPadScroll').scrollTop =
              currentScrollTop + (targetY - scrollWrapY);
          } else if (index === '13') {
            followRef14.current.onFocusInput();
          } else if (index === '14') {
            followRef10.current.onFocusInput();
          }
        }, 100);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="txt-pad-wrap">
        보험계약자
        <SatFollowText
          ref={followRef1}
          followText={ownerName}
          onMatched={v => handleMatched(v, '1')}
          complete={complete}
        />
        은(는) 위 내용에 대해
        <SatFollowText
          ref={followRef2}
          followText={'비교확인'}
          onMatched={v => handleMatched(v, '2')}
          complete={complete}
        />
        하였습니다.
        <br />
        본인이 선택한
        <SatFollowText
          ref={followRef3}
          followText={'해약환급금 일부지급형'}
          onMatched={v => handleMatched(v, '3')}
          complete={complete}
        />
        상품은
        <br />
        <SatFollowText
          ref={followRef4}
          followText={'보험료 납입기간 중 중도해지시'}
          onMatched={v => handleMatched(v, '4')}
          complete={complete}
        />
        해약환급금이
        <SatFollowText
          ref={followRef5}
          followText={'표준형 해약환급금의'}
          onMatched={v => handleMatched(v, '5')}
          complete={complete}
        />
        <SatFollowText
          ref={followRef6}
          followText={'50%'}
          onMatched={v => handleMatched(v, '6')}
          complete={complete}
        />
        이고,
        <SatFollowText
          ref={followRef7}
          followText={'해약환급금 미지급형'}
          onMatched={v => handleMatched(v, '7')}
          complete={complete}
        />
        상품은 보험료 납입기간 중 중도해지시
        <SatFollowText
          ref={followRef8}
          followText={'해약환급금이 없으며'}
          onMatched={v => handleMatched(v, '8')}
          complete={complete}
        />
        보험료 납입기간이 완료된 이후 중도해지시 해약환급금이
        <SatFollowText
          ref={followRef9}
          followText={
            isRefundHalf ? '표준형보다 적습니다' : '표준형 해약환급금의 50%'
          }
          onMatched={v => handleMatched(v, '9')}
          complete={complete}
        />
        {isRefundHalf ? '' : '입니다.'}
        {isExtraFollowText && (
          <>
            단, {mainProductName}은 납입기간 중 중도해지시
            <SatFollowText
              ref={followRef13}
              followText={'해약환급금이 없으며'}
              onMatched={v => handleMatched(v, '13')}
              complete={complete}
            />
            , 보험료 납입기간이 완료된 이후 중도해지시 해약환급금이
            <SatFollowText
              ref={followRef14}
              followText={'표준형보다 적습니다'}
              onMatched={v => handleMatched(v, '14')}
              complete={complete}
            />
          </>
        )}
        {isCaution && (
          <>
            <br />
            ※ 그럼에도 불구하고, 「라이프케어보험금」 지급사유 발생 후 계약이
            해지되는 경우에 주계약의 해약환급금은 표준형 주계약의 해약환급금과
            동일한 금액을 지급합니다.
            <br />
          </>
        )}
        {/* {additionalText ? (
          <>
            <br />
            {isNewProduct
              ? `※ 그럼에도 불구하고, 「라이프케어보험금」 지급사유 발생 후 계약이 해지되는 경우에 주계약의 해약환급금은 표준형 주계약의 해약환급금과 동일한 금액을 지급합니다.`
              : `※ 다만, 「라이프케어보험금」 지급사유 발생 후 계약이 해지되는 경우에는 표준형의 해약환급금과 동일한 금액을 지급합니다.`}
            <br />
          </>
        ) : (
          <> </>
        )} */}
        또한
        <SatFollowText
          ref={followRef10}
          followText={'저축목적으로 가입'}
          onMatched={v => handleMatched(v, '10')}
          complete={complete}
        />
        할 경우
        <SatFollowText
          ref={followRef11}
          followText={'다른 상품을 선택하는 것이 유리'}
          onMatched={v => handleMatched(v, '11')}
          complete={complete}
        />
        할 수 있음을 확인하였습니다.
        <br />
        상기 비교 사항을 충분히
        <SatFollowText
          ref={followRef12}
          followText={'이해'}
          onMatched={v => handleMatched(v, '12')}
          complete={complete}
        />
        하고 계약을 체결하였습니다.
      </div>

      <SatValidationErrMsg
        visible={showError && followTextError}
        type="error"
        message="내용을 확인하고 따라쓰기를 해주세요."
      />
    </React.Fragment>
  );
});

export default ComplexPaymentFollowText;
